export { useWifiData } from "./useWifiData";
